export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary-dark text-white">
      <div className="w-full px-4 md:px-8 lg:px-12 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-10 mb-12">
            <div className="md:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/ad23bf20-8f1c-4820-8d59-048f8dd2f26d/a4684e0c-234a-43ae-8a03-2cd9ddcc417f_MEDUMED.png?v=3283a57381ef6d7183af864b44c636e6"
                    alt="MEDUMED"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div>
                  <p className="text-sm font-bold">MEDUMED3</p>
                  <p className="text-xs text-white/50">UAN - CEDUMED</p>
                </div>
              </div>
              <p className="text-white/60 text-sm leading-relaxed">
                Centro de Estudos Avançados em Educação e Formação Médica
                da Faculdade de Medicina da Universidade Agostinho Neto.
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4">Programa</h4>
              <div className="w-10 h-0.5 bg-accent mb-4" />
              <ul className="space-y-2.5">
                <li>
                  <a href="#sobre" onClick={(e) => handleNavClick(e, '#sobre')} className="text-white/60 text-sm hover:text-accent transition-colors">
                    Sobre o Mestrado
                  </a>
                </li>
                <li>
                  <a href="#curriculo" onClick={(e) => handleNavClick(e, '#curriculo')} className="text-white/60 text-sm hover:text-accent transition-colors">
                    Estrutura Curricular
                  </a>
                </li>
                <li>
                  <a href="#cronograma" onClick={(e) => handleNavClick(e, '#cronograma')} className="text-white/60 text-sm hover:text-accent transition-colors">
                    Cronograma
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4">Admissão</h4>
              <div className="w-10 h-0.5 bg-accent mb-4" />
              <ul className="space-y-2.5">
                <li>
                  <a href="#admissao" onClick={(e) => handleNavClick(e, '#admissao')} className="text-white/60 text-sm hover:text-accent transition-colors">
                    Requisitos
                  </a>
                </li>
                <li>
                  <a href="#admissao" onClick={(e) => handleNavClick(e, '#admissao')} className="text-white/60 text-sm hover:text-accent transition-colors">
                    Documentação
                  </a>
                </li>
                <li>
                  <a href="#admissao" onClick={(e) => handleNavClick(e, '#admissao')} className="text-white/60 text-sm hover:text-accent transition-colors">
                    Propinas
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-sm mb-4">Contacto</h4>
              <div className="w-10 h-0.5 bg-accent mb-4" />
              <ul className="space-y-2.5">
                <li className="text-white/60 text-sm flex items-center gap-2">
                  <i className="ri-mail-line text-accent" />
                  medumed@cedumed.ao
                </li>
                <li className="text-white/60 text-sm flex items-center gap-2">
                  <i className="ri-phone-line text-accent" />
                  923 572 487
                </li>
                <li className="text-white/60 text-sm flex items-center gap-2">
                  <i className="ri-map-pin-line text-accent" />
                  FM/UAN, Luanda
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-2">
            <p className="text-white/40 text-xs">
              © 2023-2025 Universidade Agostinho Neto - Faculdade de Medicina. Todos os direitos reservados.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-1 md:gap-4">
              <p className="text-white/40 text-xs">
                Subvencionado pela União Europeia - Programa UNIAO
              </p>
              <span className="text-white/40 text-xs hidden md:inline">|</span>
              <a
                href="https://sysadmin.it.ao"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/30 text-xs font-semibold hover:text-accent transition-colors"
              >
                Desenvolvido por SYSADMIN-T.I
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}